<div class="flex flex-col max-w-240 md:min-w-160 -m-6" cdkDrag cdkDragRootElement=".cdk-overlay-pane">

  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" cdkDragHandle>
    <div class="text-lg">{{ data.title }}</div>
    <button mat-icon-button (click)="cancel()" [tabIndex]="-1">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
  </div>

  <!-- Compose form -->
  <div class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
    @if (data.message) {
      <p [innerHTML]="data.message | bypassSecurityTrustHtml"></p>
    }
  </div>

  <!-- Actions -->
  <div class="ml-auto p-6" mat-dialog-actions>
    <button
      class="clear mr-6"
      mat-button
      [color]="'primary'"
      (click)="cancel()">
      {{ (data.cancel_action || 'cancel') | transloco }}
    </button>
    <button
      mat-flat-button
      [color]="'primary'"
      (click)="confirm()">
      {{ (data.confirm_action || 'confirm') | transloco }}
    </button>
  </div>

</div>
